import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';

export function FeedVideoCardSkeleton() {
  return (
    <div className="h-[214px] rounded-[12px] overflow-hidden bg-white border border-[#E7ECF3] shadow-[0_1px_2px_rgba(16,24,40,.04)]">
      <div className="relative h-full">
        <Skeleton className="w-full h-full rounded-none" />
        <div className="absolute bottom-0 left-0 right-0 p-3.5 space-y-2">
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-3 w-1/3" />
        </div>
      </div>
    </div>
  );
}
